import { useSetNotice } from 'hooks/useSetNotice'
import { Severity } from 'widget/Notifications'

import { TAppealManagerResponse } from '../type'

//  обработчик ошибок
export const useErrorHandler = () => {
  const setNotice = useSetNotice()

  const errorHandler = (responce: TAppealManagerResponse) => {
    if (responce.code === 422 && responce?.context?.location) {
      setNotice(responce?.context?.location, Severity.error)
      return
    }

    if (responce.code === 422 && responce?.context?.status) {
      setNotice(responce?.context?.status, Severity.error)
      return
    }

    setNotice(responce?.message || 'Ошибка', Severity.error)
  }

  return errorHandler
}
